const data1 = [
    {
        id: 1,
        name: "Airplane",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/airplane/airplane.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/airplane/airplane.glb"
      }
  ,
    {
        id: 2,
        name: "Arrow",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/arrow/arrow.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/arrow/arrow.glb"
      }
  ,
    {
        id: 3,
        name: "Boombox",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/boombox/boombox.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/boombox/boombox.glb"
      }
  ,
    {
        id: 4,
        name: "Cake",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/cake/cake.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/cake/cake.glb"
      }
  ,
    {
        id: 5,
        name: "Cat",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/cat/cat.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/cat/cat.glb"
      }
  ,
    {
        id: 6,
        name: "Champagne",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/champagne/champagne.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/champagne/champagne.glb"
      }
  ,
    {
        id: 7,
        name: "Cloud",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/cloud/cloud.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/cloud/cloud.glb"
      }
  ,
    {
        id: 8,
        name: "Cocktail",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/cocktail/cocktail.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/cocktail/cocktail.glb"
      }
  ,
    {
        id: 9,
        name: "Coffee",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/coffe/coffee.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/coffe/coffee.glb"
      }
  ,
    {
        id: 10,
        name: "Dog",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/dog/dog.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/dog/dog.glb"
      }
  ,
    {
        id: 11,
        name: "Fire",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/fire/fire.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/fire/fire.glb"
      }
  ,
    {
        id: 12,
        name: "Gallerytree",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/gallerytree/gallerytree.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/gallerytree/gallerytree.glb"
      }
  ,
    {
        id: 13,
        name: "Gallerytree2",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/gallerytree2/gallerytree2.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/gallerytree2/gallerytree2.glb"
      }
  ,
    {
        id: 14,
        name: "Heart",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/heart/heart.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/heart/heart.glb"
      }
  ,
    {
        id: 15,
        name: "Hourglass",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/hourglass/hourglass.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/hourglass/hourglass.glb"
      }
  ,
    {
        id: 16,
        name: "Mask",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/mask/mask.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/mask/mask.glb"
      }
  ,
    {
        id: 17,
        name: "Megaphone",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/megaphone/megaphone.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/megaphone/megaphone.glb"
      }
  ,
    {
        id: 18,
        name: "Pipe",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/pipe/pipe.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/pipe/pipe.glb"
      }
  ,
    {
        id: 19,
        name: "Plant",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/plant/plant.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/plant/plant.glb"
      }
  ,
    {
        id: 20,
        name: "Rubikscube",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/rubikscube/rubikscube.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/rubikscube/rubikscube.glb"
      }
  ,
    {
        id: 21,
        name: "Sandwich",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/sandwich/sandwich.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/sandwich/sandwich.glb"
      }
  ,
    {
        id: 22,
        name: "Sunglasses",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/sunglasses/sunglasses.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/sunglasses/sunglasses.glb"
      }
  ,
    {
        id: 23,
        name: "Trashcan",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/trashcan/trashcan.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/trashcan/trashcan.glb"
      }
  ,
    {
        id: 24,
        name: "Wand",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/wand/wand.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/wand/wand.glb"
      }
  ,
    {
        id: 25,
        name: "Wineglass",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-files/wineglass/wineglass.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-files/wineglass/wineglass.glb"
      }
  ];
  
  export default data1;
  